import {BaseFormModel} from './base-form-model';
import {MenuModifier} from './menu-modifier';

export class MenuModifierSelectionOption extends BaseFormModel<MenuModifierSelectionOption> {
    id: number;
    menuModifier: MenuModifier;
    sortOrder: number;
    defaultOption: boolean;
    modifierDisplayPosition: string;
}
